<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">官方面料信息列表</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1">
            <div class="label">品名编号</div>
            <el-select
              v-model="bh"
              placeholder="请选择品名编号"
              style="width: 100%"
              clearable
              filterable
            >
              <el-option
                v-for="item in bhlist"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
          <div class="item col-1">
            <div class="label">商家名</div>
            <label>
              <input type="text" class="cg-input" v-model="username" />
            </label>
          </div>
          <div class="item col-1">
            <div class="label">商家编号</div>
            <label
              ><input type="text" class="cg-input" v-model="sjname"
            /></label>
            <div class="form-options">
              <el-button class="publish-btn" size="small" @click="search"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table
      :data="users"
      border
      height="500px"
      style="width: 100%"
      class="custom-table"
      row-key="id"
    >
      <!-- 折叠展开列：点开展示供应商列表 -->
      <el-table-column type="expand">
        <template #default="{ row }">
          <div class="expand-supplier-wrap">
            <el-table
              :data="getVisibleSupplier(row.supplierList)"
              border
              style="width: 100%; margin-top: 10px"
            >
              <el-table-column prop="name" label="商家名" align="center" />
              <el-table-column
                prop="memberProductName"
                label="商家产品编号"
                align="center"
              />
              <el-table-column prop="date" label="录入时间" align="center">
                <template #default="scope">
                  <span>{{
                    scope.row.date
                      ? $day(scope.row.date).format("YYYY-MM-DD")
                      : "-"
                  }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        label="品名编号"
        show-overflow-tooltip
      />
      <el-table-column align="center" prop="width" label="幅宽" />
      <el-table-column align="center" prop="weight" label="克重" />
      <el-table-column
        align="center"
        prop="ingredients"
        label="成份"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        prop="quantify"
        label="量化"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        prop="yarnCount"
        label="纱支"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        prop="density"
        label="密度"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        prop="specification"
        label="规格"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        prop="remark"
        label="备注"
        show-overflow-tooltip
      />
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <div class="options">
            <i
              class="update-icon el-icon-edit"
              title="修改"
              @click="up(scope.row)"
            ></i>
            <el-popconfirm
              title="确认删除吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="delUser(scope.row.id)"
            >
              <template #reference>
                <i class="del-icon el-icon-close" title="删除"></i>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      center
      width="1500px"
      height="1200px"
      v-model="showUpdate"
      @close="handleDialogClose"
    >
      <my-dialog
        :row="editRow"
        @update-success="handleUpdateSuccess"
        @cancel="showUpdate = false"
      />
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, getCurrentInstance, watch } from "vue";
import MyDialog from "./updata/user-product-launch.vue";

const { proxy } = getCurrentInstance();

const showUpdate = ref(false);
const users = ref([]);
const editRow = ref(null);
const bh = ref("");
const bhlist = ref([]);
const username = ref("");
const sjname = ref("");

// 缓存值
const STORAGE_KEY = "base-product-list";

// 监听查询条件
watch([sjname, username, bh], () => {
  const searchParams = {
    sjname: sjname.value,
    username: username.value,
    bh: bh.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      bh.value = cache.bh ?? "";
      username.value = cache.username ?? "";
      sjname.value = cache.sjname ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

//获取品名编号列表
const getpm = async () => {
  const sendata = `name=${encodeURIComponent(
    bh.value
  )}&memberName=${encodeURIComponent(
    username.value
  )}&memberProductName=${encodeURIComponent(sjname.value)}`;
  const res = await proxy.$api.Operation.Baseproduct.get(sendata);
  if (res.data.code == "200") {
    bhlist.value = res.data.data.list.map((item) => item.name);
    console.log(bhlist.value, "返回什么品名列表");
  } else {
    proxy.$message.error("网络错误");
    bhlist.value = [];
  }
};

//过滤供应商，只展示delflag !==0
const getVisibleSupplier = (supplierList) => {
  if (!supplierList || !Array.isArray(supplierList)) return [];
  return supplierList.filter((item) => item.delflag !== 0);
};

const handleUpdateSuccess = () => {
  showUpdate.value = false;
  proxy.$message.success("修改面料信息成功");
  getList(); // 重新获取数据
};

const up = (row) => {
  console.log(row, "里面是什么数据");
  //清空
  editRow.value = null;
  nextTick(() => {
    editRow.value = { ...row }; // 深拷贝
    showUpdate.value = true;
  });
};

const search = async () => {
  getList();
};

const getList = async () => {
  const sendata = `name=${encodeURIComponent(
    bh.value
  )}&memberName=${encodeURIComponent(
    username.value
  )}&memberProductName=${encodeURIComponent(sjname.value)}`;
  console.log(sendata, "查询的是什么");
  const res = await proxy.$api.Operation.Baseproduct.get(sendata);
  if (res.data.code == "200") {
    users.value = res.data.data.list;
    console.log(users.value, "返回的列表是什么格式");
  } else {
    proxy.$message.error("网络错误");
    users.value = [];
  }
};

const delUser = async (id) => {
  const sendata = { id: id };
  const res = await proxy.$api.Operation.Baseproduct.del(sendata);
  if (res.data.code == 200) {
    proxy.$message.success("删除成功");
    getList();
  } else {
    proxy.$message.error("网络错误");
  }
  console.log(id);
};

const handleDialogClose = () => {
  editRow.value = null;
};

onMounted(() => {
  getpm();
  loadSearchCache();
  getList();
});
</script>

<style lang="scss" scoped>
@import "./base-product-list.scss";
.panel-title {
  color: #999;
}
.expand-supplier-wrap {
  padding: 12px 20px;
  h4 {
    margin: 0 0 8px 0;
  }
  .empty-tip {
    color: #999;
    padding: 12px;
  }
}

.publish-btn {
  background-color: #ff9900;
}
</style>
